import { render } from "./FormRadio.vue?vue&type=template&id=8d2c4658"
import script from "./FormRadio.vue?vue&type=script&lang=ts"
export * from "./FormRadio.vue?vue&type=script&lang=ts"
script.render = render

export default script